export type RenderAt = 'Global' | 'Corporation' | 'Location';

export const SettingsRouteNames = [
    'models',
    'applicationTypes',
    'assetTypes',
    'bearings',
    'corporation',
    'corporations',
    'clientSoftware',
    'fileLibrary',
    'identityProviders',
    'industries',
    'integrations',
    'location',
    'locations',
    'notificationSubscriptions',
    'setupTools',
    'templates',
    'thirdPartySensors',
    'timeRanges',
    'users',
    'v4SensorSettings',
] as const;

export type SettingsRoute = (typeof SettingsRouteNames)[number];

const RenderAtAll: RenderAt[] = ['Global', 'Corporation', 'Location'];

const SettingsRouteRenderAt: Record<SettingsRoute, RenderAt[]> = {
    models: RenderAtAll,
    applicationTypes: ['Global'],
    assetTypes: ['Global'],
    bearings: RenderAtAll,
    corporation: ['Corporation', 'Location'],
    corporations: ['Global'],
    clientSoftware: ['Global'],
    fileLibrary: ['Corporation', 'Location'],
    identityProviders: ['Global'],
    industries: ['Global'],
    integrations: ['Location'],
    location: ['Location'],
    locations: ['Global', 'Corporation'],
    notificationSubscriptions: RenderAtAll,
    setupTools: RenderAtAll,
    templates: ['Location'],
    thirdPartySensors: ['Global'],
    timeRanges: ['Global'],
    users: RenderAtAll,
    v4SensorSettings: ['Location'],
};

export const shouldRenderSettingsRoute = (
    route: string,
    targetLevel: RenderAt,
): boolean => {
    const renderAt = SettingsRouteRenderAt[route as SettingsRoute];
    // This is introduced by the above cast
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (renderAt === undefined) {
        return false;
    }
    return renderAt.includes(targetLevel);
};
